import React, { useEffect, useState } from 'react'
import { hideLoader, showLoader } from '../loader';
import { apiUrl } from '../../utils/url';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const TeamStep = ({moveNext, moveBack}) => {
    const [values,setValues] = useState({email:null})
    const { slug } = useSelector(state => state?.slugReducer);
    const [teamMembers, setTeamMembers] = useState([]);

    function sendInvite(e) {
        showLoader()
        e?.preventDefault()
        if (teamMembers.some(member => member.email === values?.email)) {
            toast.error('This email address has already been added');
            hideLoader();
            return;
        }
        let errorList = [];
        const api = apiUrl + `/settings/team-members/check-email`;
        var form_data = new FormData();
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        var link = slug ? slug :localStorage.getItem("slug");
        form_data.append("project", link);
        form_data.append("email", values?.email);
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: form_data
        }
        fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code === 200) {
                    // toast.success(response.status_message)
                    setTeamMembers(prevMembers => [...prevMembers, { email: values?.email }]);
                    // getdata()
                    setValues({});
                    hideLoader()
                }
                else {
                    response?.errors?.email?.map((val) => errorList?.push(val));
                    response?.errors?.member?.map((val) => errorList?.push(val));
                    if (errorList.length !== 0) {
                        hideLoader()
                        errorList?.map((err) => {
                            return (
                                toast.error(err)
                            );
                        });
                    }
                    else {
                        toast.error(response?.status_message)
                    }
                    hideLoader()
                }

            }).catch((err) => {
                toast.error(err)
            })
    }
    const handleChange = (e) => {
        setValues({...values,[e.target.name]:e.target.value})
    }
    const nextStep = (e, from) => {
        showLoader();
        var myHeaders = new Headers();

        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData();
        formdata.append('step',3)
        formdata.append('project',slug ?slug: localStorage?.slug)
        teamMembers?.forEach(member => {
            if(!member?.id){
                formdata.append('invitation_emails[]', member?.email);
            }
        });
        if (from == 'back') {
            formdata.append('back',1)
        }
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(apiUrl + "/walkthrough", requestOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    if (from == "next" || from == "skip") {
                        toast.success(response?.status_message)

                        hideLoader()
                        moveNext(e, 4)
                    }
                    else if (from == "back") {
                        moveBack(e, response)

                        hideLoader()
                    }
                }
                else {
                    toast.error(response?.status_message)

                    hideLoader()
                }

            }).catch((err) => {
                hideLoader()
            })
    }
    useEffect(() => {
        try {
            const state = JSON.parse(localStorage?.backStepValue)
            
            if (state?.members) setTeamMembers(state?.members)
        } catch { }
    }, [localStorage?.backStepValue])
    function removedata(val) {
        showLoader()
        if (val?.id) {
        const api = apiUrl + `/settings/team-members/delete/${val?.id}`;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        };

        fetch(api, setOptions
        ).then(async (res) => {
            const response = await res.json();
            
            if (response?.status_code === 200) {
                if (response?.data?.action != "back to dashboard") getdata()
                else {
                    history.push("/dashboard")
                    toast.success(response.status_message)
                }
            }
            else {
                toast.error(response.status_message)
                hideLoader()
            }
        })
            .catch((error) => {
                console.error("Error:", error);
            });
        }else {
            setTeamMembers(prevMembers => 
                prevMembers.filter(member => member?.email !== val?.email)
            );
            hideLoader()
        }
    }
    function getdata() {
        let errorList = [];
        showLoader()
        if (localStorage?.slug) {
            const api = apiUrl + `/settings/team-members/get/${localStorage?.slug}`;
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const setOptions = {
                method: "GET",
                headers: myHeaders,
            };

            fetch(api, setOptions).then(async (res) => {
                const response = await res.json();
                if (response.status_code === 200) {
                    setTeamMembers(response?.data?.team_members)
                    hideLoader()
                }
                else {
                    response?.errors?.project?.map((val) => errorList?.push(val));
                    if (errorList.length !== 0) {
                        errorList?.map((err) => {
                            if (err == "Invalid Project") {
                                history.push("/dashboard")
                                toast.error(err)
                            }
                            else {
                                toast.error(err)
                            }
                        });
                    }
                    else {
                        toast.error(response?.status_message)
                    }
                    hideLoader()
                }
            })
                .catch((error) => {
                    toast.error(error)
                    hideLoader()
                });
        }
    }
    useEffect(()=>{
        if (localStorage?.slug) {
            getdata()
        }
    },[])
  return (
    <div>
        <div className="step-heading">Invite your team</div>
        <form className='step-form' action="" onSubmit={(e) => sendInvite(e)}>
            <div className='form-group  mt-20px'>
                <label className='step-label'>Email address</label>
                <div className='d-flex gap-1'>
                    <input type='email' name='email' required value={values?.email || ''} onChange={handleChange} className='zaapGlobal-input h-30px ' placeholder='Enter teammate email address'/>
                    <button type='submit' className='add-member-btn'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
                            <path d="M7.5 8.63889H4.575C3.66788 8.63889 3.21433 8.63889 2.84526 8.74414C2.0143 8.98113 1.36403 9.5925 1.11196 10.3737C1 10.7207 1 11.1472 1 12M10.1 10.1667L11.4 11.3889L14 8.94444M9.125 3.75C9.125 5.26878 7.81543 6.5 6.2 6.5C4.58457 6.5 3.275 5.26878 3.275 3.75C3.275 2.23122 4.58457 1 6.2 1C7.81543 1 9.125 2.23122 9.125 3.75Z" stroke="#183C81" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>
                            Add
                        </span>
                    </button>
                </div>
            </div>
            {teamMembers?.length > 0 &&
                <div className='form-group members-list mt-20px'>
                    {
                        teamMembers?.map((val,index)=>(
                            <div key={index} className='member-email justify-content-between'>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
                                        <path d="M7.5 8.63889H4.575C3.66788 8.63889 3.21433 8.63889 2.84526 8.74414C2.0143 8.98113 1.36403 9.5925 1.11196 10.3737C1 10.7207 1 11.1472 1 12M10.1 10.1667L11.4 11.3889L14 8.94444M9.125 3.75C9.125 5.26878 7.81543 6.5 6.2 6.5C4.58457 6.5 3.275 5.26878 3.275 3.75C3.275 2.23122 4.58457 1 6.2 1C7.81543 1 9.125 2.23122 9.125 3.75Z" stroke="#183C81" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <span className='ms-2'>{val?.email}</span>
                                </span>
                                <div className='cursor-pointer' onClick={() => removedata(val)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
                                        <path d="M8 1.5L1 8.5M1 1.5L8 8.5" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                        ))
                    }
                </div>
            }
            <div className='skip-button-container'>
                <div className='walkthrough-steps-footer ms-0'>
                    <button
                        onClick={(e) =>
                            nextStep(e, "back", {
                                back: 1,
                                step: 3
                            })} type="button" className="w-100 register-btn border-0"
                        data-backstep="2">Back</button>
                    <button type="button" onClick={(e) => nextStep(e,'next')} name="submit"  className="fs-12 w-100 shadow-none  project-blue-btn ">
                        Continue
                    </button>
                </div>
                <button data-step="3" type="button" class="skip-button ms-auto"
                onClick={(e) =>nextStep(e, "skip")}
                >
                    Skip
                </button>
            </div>
        </form>
    </div>
  )
}

export default TeamStep